import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { eventOccurrenceAsMemberQueryKeys } from "./eventOccurrenceAsMemberQueryKeys";

export const useInfiniteQueryEventRsvpPastAsMember = ({
  api,
  filters,
  enabled,
}: {
  api: ApiType;
  filters: Parameters<
    ApiType["customerOccurrenceApi"]["eventRsvpPast"]
  >[0]["filters"];
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey: eventOccurrenceAsMemberQueryKeys.eventRsvpPast(filters),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      return (
        await api.customerOccurrenceApi.eventRsvpPast({
          filters: {
            ...filters,
            nextPageToken: pageParam,
          },
        })
      ).data;
    },
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    initialPageParam: undefined,
    enabled,
  });
